import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class LayoutService {

  readonly defaultShowLayoutState = true;

  showLayout: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(this.defaultShowLayoutState);

  constructor() { }

  resetShowLayout(): void {
    this.showLayout.next(this.defaultShowLayoutState);
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/services/layout.service.ts